export const HEADER_CONTENT_PORTAL_ID = 'header-content-portal';
